import { useMutation } from "react-query";
import api from "../../client";
import {
  CreatePeoplePayload,
  CreatePeopleResponseData,
} from "../../types/people";

const postData = async (
  payload: CreatePeoplePayload,
): Promise<CreatePeopleResponseData> => {
  const { data } = await api.post<CreatePeopleResponseData>(
    `/profile`,
    payload,
  );

  return data;
};

export const useCreatePeople = () => {
  return useMutation((payload: CreatePeoplePayload) => {
    return postData(payload);
  });
};
